module.exports = __webpack_public_path__ + "media/images/layout/logo_m-df74f7a5130d99ae20695db4d9c84260.svg";